export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const emailValidationMessage = 'Email must be of the form user@domain.com and not contain special characters.';

export const validateEmail = (email) => {
  if (email.match(emailRegex)) {
    return { valid: true };
  }
  return { valid: false, error: emailValidationMessage };
};

export const validateFullName = (fullName) => {
  const validUserName = fullName.split(' ');
  let userNameError = null;
  let isValid = true;

  if (!fullName.length) {
    userNameError = 'Please fill out this field.';
    isValid = false;
  } else if (validUserName.length < 2) {
    userNameError = 'Please enter first and last name.';
    isValid = false;
  } else if (validUserName.some((word) => word.length < 2)) {
    userNameError = 'First and last name should be at least 2 characters each.';
    isValid = false;
  } else if (/\S+@\S+\.\S+/.test(fullName)) {
    userNameError = 'First or last name cannot be an email address.';
    isValid = false;
  }

  return { isValid, error: userNameError };
};
